import React from "react";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import CheckboxIcon from "Assets/images/new-checkbox.svg";
import CheckboxCheckedIcon from "Assets/images/new-checkbox-select.svg";
import useStyles from "./styles";

const CheckboxWithLabel = props => {
  const classes = useStyles();
  const { elementData = null } = props;
  return (
    <FormControlLabel
      className={classes.root}
      control={
        <Checkbox
          icon={<img src={CheckboxIcon} />}
          checkedIcon={<img src={CheckboxCheckedIcon} />}
          inputProps={{ "data-testid": "input-change" }}
          checked={props.checked}
          onChange={e => 
              props?.handleChange?.(e, props.index, elementData)
          }
          name={props.name}
          value={props.value}
          disabled={props.disabled}
        />
      }
      label={props.label}
    />
  );
};

export default CheckboxWithLabel;
